import { render, staticRenderFns } from "./success-feedback.vue?vue&type=template&id=952ef51e&scoped=true&lang=pug"
import script from "./success-feedback.vue?vue&type=script&setup=true&lang=js"
export * from "./success-feedback.vue?vue&type=script&setup=true&lang=js"
import style0 from "./success-feedback.vue?vue&type=style&index=0&id=952ef51e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "952ef51e",
  null
  
)

export default component.exports